<template>
  <div>
    <div class="top-page-content">
      <rego-search></rego-search>
      <car-info></car-info>
      <why-use></why-use>
      <quick-question class="pb-50"></quick-question>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
import RegoSearch from "@/components/top-page/RegoSearch";
import CarInfo from "@/components/top-page/Info";
import QuickQuestion from "@/components/top-page/QuickQuestion";
import FooterView from "@/components/layout/Footer";
import WhyUse from "../../components/top-page/WhyUse.vue";
import { GET_NZ_VARIABLES } from "@/store/common-variables/actions";

export default {
  name: "Index",
  components: {
    RegoSearch,
    CarInfo,
    QuickQuestion,
    FooterView,
    WhyUse,
  },
  async mounted() {
    this.$store.dispatch(GET_NZ_VARIABLES);
    await this.$store.dispatch('getSystemConfigurations');
  },
};
</script>

<style lang="scss">
.top-page-content {
  color: #404040;
  text-align: center;
  background-color: #efefef;
  overflow-x: hidden;
}
</style>
